export const Input = (props) => {
  return (<div className="mb-4">
      <label htmlFor={props.id} className={`block font-medium text-sm text-white ` + props.className}>{props.label}</label>
        <input id={props.id}
                        type={props.type}
                        name={props.id}
                        value={props.data[props.id]}
                        className="mt-1 p-2 block w-full text-black border-gray-300 focus:border-indigo-500 focus:ring-indigo-500 rounded-md shadow-sm"
                        autoComplete={props.id}
                        placeholder={props.placeholder}
                        onChange={props.onChange}
                        required={props.required === "no" ? false : true}
                    />
      <InputError message={props.errors[props.id]} className="mt-2" />
   </div>
  )
}

export const InputDropdown = (props, {children}) => {
    return (<div className="mb-4">
                      <label htmlFor={props.id} className={`block font-medium text-sm text-white ` + props.className}>{props.label}</label>
                      <select
                          id={props.id}
                          type={props.type}
                          name={props.id}
                          value={props.data[props.id]}
                          className="mt-1 p-2 block w-full text-black border-gray-300 focus:border-indigo-500 focus:ring-indigo-500 rounded-md shadow-sm"
                          autoComplete={props.id}
                          onChange={props.onChange}
                          required
                      >
                        <option value="choose">choose</option>
                        {props?.obj?.map((item, index) => (
                            <option key={index} value={item?.id || item}>{item?.body || item}</option>
                        ))}
                        {children}
                        </select>
  
        <InputError message={props?.errors[props.id]} className="mt-2" />
     </div>
    )
  }

  function InputError({ message, className = '', ...props }) {
    return message ? (
        <p {...props} className={'text-sm text-red-600 ' + className}>
            {message}
        </p>
    ) : null;
}

export const Button=(props)=>{
  return <button
  type="button"
  onClick={props.onClick}
  className={`w-full bg-blue-500 text-white p-2 rounded hover:bg-blue-600 ${props.styles}`}
>
  {props.label}
</button>
}